import { calculateRect } from '../utils.js';
import { resolveNode } from '../utils/responsive.js';

export class SelectionManager {
  static getNodesInSelectionBox(nodes, selectionBox, rootW, rootH, activeBreakpoint = 'default') {
    const x1 = Math.min(selectionBox.startX, selectionBox.currentX);
    const x2 = Math.max(selectionBox.startX, selectionBox.currentX);
    const y1 = Math.min(selectionBox.startY, selectionBox.currentY);
    const y2 = Math.max(selectionBox.startY, selectionBox.currentY);

    const selectableNodes = selectionBox.contextId
      ? nodes.filter(n => n.parentId === selectionBox.contextId)
      : nodes.filter(n => !n.parentId);

    return selectableNodes.filter(n => {
      const resolvedNode = resolveNode(n, activeBreakpoint);

      // Check if disabled - skip disabled nodes
      const isEnabled = resolvedNode.props?.enabled !== false;
      if (!isEnabled) return false;

      // Check visibility (edit mode only)
      let isVisible = true;
      if (resolvedNode.props?.visibility !== undefined) {
        if (typeof resolvedNode.props.visibility === 'boolean') {
          isVisible = resolvedNode.props.visibility;
        } else if (activeBreakpoint && typeof resolvedNode.props.visibility === 'object') {
          if (resolvedNode.props.visibility[activeBreakpoint] === false) {
            isVisible = false;
          }
        }
      }
      if (!isVisible) return false;

      const r = calculateRect(resolvedNode, rootW, rootH);
      return r.x < x2 && r.x + r.width > x1 && r.y < y2 && r.y + r.height > y1;
    }).map(n => n.id);
  }

  static resolveContextualNodeId(leafId, activeNodes, containerNode) {
    let currentContextId = containerNode?.id;
    const isContainerInternal = containerNode && activeNodes.some(n => n.id === containerNode.id);

    if (!isContainerInternal && activeNodes.length > 0) {
      const roots = activeNodes.filter(n => !n.parentId);
      if (roots.length === 1) {
        currentContextId = roots[0].id;
      }
    }

    let curr = activeNodes.find(n => n.id === leafId);
    while (curr && curr.parentId !== currentContextId) {
      if (!curr.parentId) break;
      const parent = activeNodes.find(n => n.id === curr.parentId);
      if (!parent) break;
      curr = parent;
    }

    return curr?.id || leafId;
  }

  static getSelectedNodesWithRoots(selectedNodeIds, activeNodes) {
    return selectedNodeIds.filter(id => {
      const n = activeNodes.find(x => x.id === id);
      if (!n) return false;

      let p = activeNodes.find(x => x.id === n.parentId);
      while (p) {
        if (selectedNodeIds.includes(p.id)) return false;
        p = activeNodes.find(x => x.id === p.parentId);
      }
      return true;
    });
  }

  static areNodesSiblings(nodeIds, activeNodes) {
    if (nodeIds.length === 0) return false;

    const nodes = activeNodes.filter(n => nodeIds.includes(n.id));
    const parentIds = [...new Set(nodes.map(n => n.parentId))];

    return parentIds.length === 1;
  }

  static getCommonParent(nodeIds, activeNodes) {
    if (nodeIds.length === 0) return null;

    const nodes = activeNodes.filter(n => nodeIds.includes(n.id));
    const firstParentId = nodes[0]?.parentId;

    const allSameParent = nodes.every(n => n.parentId === firstParentId);
    return allSameParent ? firstParentId : null;
  }
}
